import { FC, useEffect, useState, useRef } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { authService } from '../services/authService'
import { useAuth } from '../components/auth/AuthContext'
import { Spinner } from '../components/ui/Spinner'
import toast from 'react-hot-toast'

export const GuarantorLoginRoute: FC = () => {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')
  const navigate = useNavigate()
  const { refreshAuth } = useAuth()
  const [validating, setValidating] = useState(true)
  const isStarted = useRef(false)

  useEffect(() => {
    const validateGuarantorToken = async () => {
      if (isStarted.current) return
      isStarted.current = true

      if (!token) {
        toast.error('Token de invitación no válido o faltante')
        navigate('/login', { replace: true })
        return
      }

      try {
        setValidating(true)
        const responseData = await authService.loginGuarantor(token)

        if (responseData?.success) {
          refreshAuth()
          toast.success('Sesión iniciada como AVAL')

          console.log(
            '✅ Guarantor login successful, checking navigation requirements...'
          )

          // PRIORIDAD 1: mustChangePassword = true
          const mustChangePassword = authService.getMustChangePassword()
          if (mustChangePassword) {
            console.log(
              '🔑 mustChangePassword detected, password change flow takes priority'
            )
            navigate('/create-password', { replace: true })
            return
          }

          // PRIORIDAD 2: Usuario sin credit-application debe ir a pending-proposals
          try {
            const shouldBeRestricted =
              await authService.shouldBeRestrictedToPendingProposals()
            if (shouldBeRestricted) {
              console.log('🚫 User must be restricted to pending-proposals')
              navigate('/onboarding/pending-proposals', { replace: true })
              return
            }
          } catch (error) {
            console.error(
              '❌ Error checking pending-proposals restriction:',
              error
            )
          }

          // PRIORIDAD 3: Verificar progressURL normal
          try {
            const progressURL = await authService.getCreditApplicationProgress()
            if (progressURL) {
              console.log('🎯 Progress URL found, redirecting to:', progressURL)
              navigate(progressURL, { replace: true })
              return
            }
          } catch (error) {
            console.error('❌ Error checking progress URL:', error)
          }

          // Redirigir al pipeline u onboarding de aval
          // Por ahora los enviamos al dashboard
          navigate('/dashboard', { replace: true })
        } else {
          toast.error('Ocurrió un error al validar el token de aval')
          navigate('/login', { replace: true })
        }
      } catch (error: any) {
        console.error('Error validating guarantor token:', error)
        toast.error(
          error.response?.data?.message || 'Error al validar el acceso de Aval'
        )
        navigate('/login', { replace: true })
      } finally {
        setValidating(false)
      }
    }

    validateGuarantorToken()
  }, [token, navigate])

  if (validating) {
    return (
      <div className="flex flex-col flex-1 min-h-screen bg-gray-50 items-center justify-center p-4">
        <Spinner size="lg" className="mb-4" />
        <h2 className="text-xl font-semibold text-gray-800">
          Validando invitación...
        </h2>
        <p className="text-gray-500 mt-2">
          Por favor espera mientras verificamos tu acceso seguro.
        </p>
      </div>
    )
  }

  return null
}
